import { useQuery } from '@tanstack/react-query'
import { getWebsiteThemes } from 'src/editor/api/website-themes-api'
import { WebsiteThemesResponseInterface } from 'src/shared/types/website-settings-types'

export const useWebsiteThemes = () => {
  return useQuery<WebsiteThemesResponseInterface, Error>({
    queryKey: ['websiteThemes'],
    queryFn: () => getWebsiteThemes(),
    staleTime: 1000 * 60 * 5,
  })
}
